function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 15v2.142c4.897.813 8.089 2.372 10.966 4.88.61.53 2.544 2.373 2.366 2.208C17.502 26.245 19.092 27 22 27c6.543 0 8.834-9.196 3.754-12H17v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1H2zm28.301 3.023a2 2 0 0 1 .012 3.953C29.522 25.675 26.544 29 22 29c-3.47 0-5.517-.972-8.029-3.304.148.138-1.749-1.67-2.319-2.167C8.897 21.128 5.859 19.704.859 18.99A1 1 0 0 1 0 18v-4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v1h4v-1a1 1 0 0 1 1-1h10c.155 0 .308.036.447.106 2.131 1.065 3.378 2.883 3.854 4.917zM13 2a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1zm6.414 5.586a1 1 0 0 1 0 1.414L18 10.414A1 1 0 0 1 16.586 9L18 7.586a1 1 0 0 1 1.414 0zm-12.828 0a1 1 0 0 1 1.414 0L9.414 9A1 1 0 1 1 8 10.414L6.586 9a1 1 0 0 1 0-1.414z"
});

var SvgReportAlt = function SvgReportAlt(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "6c29db6f394d03737b9c12ec6e677d02.svg";
export { SvgReportAlt as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/report-alt.svg
// module id = null
// module chunks = 